import _ from 'underscore';
import Backbone from 'backbone';

export var HiddenPchipModel = Backbone.Model.extend({
  defaults: function () {
    return {
      resultCode: null, // -1: 입금 기준 금액 미만/출금 금액 부족, 0 : 실패,  1 : 성공
      resultText: '', // not-allowed | fail | success
      resultMessage: '',
      isLoading: false // 중복 요청을 막기 위해 AJAX 요청 상태 저장
    };
  },

  initialize: function () {
    _.bindAll(this, 'deposit', 'withdraw');
  },

  parse: function (res) {
    var action = this.url.split('/').pop();
    var resultText = res.result.resultText;

    return _.extend(res.result, {
      resultMessage: action + '/' + resultText,
      isLoading: false
    });
  },

  deposit: function () {
    if (this.get('isLoading')) {
      return;
    }
    this.url = 'hidden-pchip/deposit';
    this.set('isLoading', true);
    this.save();
  },

  withdraw: function () {
    if (this.get('isLoading')) {
      return;
    }
    this.url = 'hidden-pchip/withdraw';
    this.set('isLoading', true);
    this.save();
  }
});
